import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { UploadModule } from '@progress/kendo-angular-upload';

import { CreateToolComponent } from './create-tool.component';

@NgModule({
    imports: [
        SharedModule,
        UploadModule
    ],
    declarations: [
        CreateToolComponent
    ],
    providers: []
})
export class TntToolModule { }
